import {
    chakra, Flex, Text
} from '@chakra-ui/react';

export const UserProfileWrapper = chakra(Flex, {
    label: 'UserProfileWrapper',
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        alignItems: 'center',
        justifyContent: 'flex-end',
        minW: '100px',
        h: '45px',
        cursor: 'pointer',
        gap: '8px'
    }
});

export const Username = chakra(Text, {
    label: 'Username',
    baseStyle: {
        fontSize: '14px',
        w: 'auto'
    }
});

export const MenuPopper = chakra(Flex, {
    label: 'MenuPopper',
    baseStyle: {
        alignItems: 'center',
        position: 'absolute',
        top: '55px',
        right: '15px',
        zIndex: '999',
        flexDirection: 'column',
        w: '324px',
        maxW: '324px',
        borderRadius: '16px',
        boxShadow: '0px 8px 8px 3px var(--3p-colors-neutral-300)',
        bgColor: '#fff',
        p: '24px 0 24px 24px',
        border: '1px solid #DBE0E6'
    }
});

export const MenuPopperItem = chakra(Flex, {
    label: 'MenuPopperItem',
    baseStyle: {
        alignItems: 'center',
        lineHeight: '15px',
        w: '100%',
        borderRadius: '5px',
        fontSize: '14px',
        cursor: 'pointer',
        _hover: { color: 'primary.600' }
    }
});
